module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "menu",
    staticClass: "sidebar-overlay-slide from-top",
    class: {
      "show": _vm.isShow
    }
  }, [_c('ul', {
    staticClass: "sidebar-system-menu clearfix"
  }, _vm._l((_vm.navTree), function(nav, index) {
    return _c('li', {
      style: (_vm._f("style")(nav)),
      on: {
        "click": function($event) {
          _vm.changeSystem(nav)
        }
      }
    }, [_vm._v(_vm._s(nav.label))])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b13ddd8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Home/Sidebar/SystemMenu.vue
// module id = 1750
// module chunks = 1